import { render, staticRenderFns } from "./GameBuilderProgressSidebar.vue?vue&type=template&id=64f8a60e&scoped=true&"
import script from "./GameBuilderProgressSidebar.vue?vue&type=script&lang=js&"
export * from "./GameBuilderProgressSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GameBuilderProgressSidebar.vue?vue&type=style&index=0&id=64f8a60e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8a60e",
  null
  
)

export default component.exports